import React from "react";
import { BlackAndWhite, colors } from "../../../themes/Colors";

const TextInputField = ({
  labelTitle,
  onChange,
  width,
  size,
  invert,
  rule,
  reqiredCheck,
  showPassword,
  autoFocus,
  value,
  placeholder,
  onClick,
  mini,
  height,
  marginTop,
  enter,
  type,
  min,
  count,
  readOnly,
  color,
  fontColor,
  fontWeight,
  borderColor,
}) => {
  return (
    <form
      onSubmit={
        enter
          ? (e) => {
              e.preventDefault();
              enter();
            }
          : (e) => e.preventDefault()
      }
      style={{
        width: width,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginTop: mini ? (marginTop ? marginTop : 10) : 20,
      }}
    >
      <label
        style={{
          width: size ? size : 240,
          fontWeight: "500",
          fontSize: mini ? 14 : 16,
          color: fontColor
            ? fontColor
            : invert
            ? colors.secondaryDarkBlue
            : colors.secondaryDarkBlue,

          position: "relative",
          textAlign: "left",
        }}
      >
        {labelTitle ? labelTitle : null}
        {reqiredCheck ? (
          <div
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              color: rule === count ? colors.greenLight : colors.orangeDark,
            }}
          >
            {rule + " / " + count}
          </div>
        ) : null}
      </label>

      <input
        autoFocus={autoFocus}
        min={min}
        style={{
          height: height ? height : 30,
          width: size ? size : 220,
          marginTop: mini ? 5 : 10,
          borderRadius: mini ? 4 : 50,
          paddingRight: 10,
          paddingTop: 8,
          paddingBottom: 8,
          paddingLeft: 20,
          fontSize: mini ? 14 : 18,
          borderStyle: invert ? "solid" : "none",
          backgroundColor: color ? color : invert ? "#FFFFFF" : "#00000009",
          color: invert
            ? fontColor
              ? fontColor
              : colors.white
            : colors.secondaryDarkBlue,
          fontWeight: fontWeight ? fontWeight : "bold",
          borderWidth: invert ? 1.5 : 0,
          borderColor: borderColor,
        }}
        readOnly={readOnly}
        type={type ? type : showPassword ? "password" : "text"}
        name={labelTitle}
        onChange={onChange}
        value={value}
        placeholder={placeholder ? placeholder : "type here"}
      />
    </form>
  );
};

export default TextInputField;
